module.exports = __webpack_public_path__ + "img/bn0712.cb86a20f.png";